import styled, { keyframes } from "styled-components";

const rotate = keyframes`
  0% {
      opacity: 0;
  }
  100% {
      opacity: 1;
  }
`;

// .formbold-main-wrapper
export const MainWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 200px;

  @media (max-width: 450px) {
    margin-bottom: 6em;
    margin-top: 50px;
  }
`;

// .profile-card
export const ProfileCard = styled.div`
  background-color: rgb(23, 60, 84);
  border: 1px rgba(254, 255, 255, 0.2) solid;
  border-radius: 31px;
  padding: 0 20px;
  box-shadow: 2px 0px 8px 4px rgba(254, 255, 255, 0.2);
  font-family: "Manrope", sans-serif;
  transition: 0.2s ease-in-out;
  animation-name: ${rotate};
  animation-duration: 3.3s;
  width: 390px;

  @media (max-width: 400px) {
    width: 338px;
  }
`;

export const CardInner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 40px;
  margin-top: 40px;
`;

export const Avatar = styled.img`
  width: 144px;
  height: 144px;
  margin-bottom: 12px;
  border-radius: 50%;
  object-fit: cover;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
  animation-name: ${rotate};
  animation-duration: 2.7s;
`;

export const Name = styled.h5`
  margin-bottom: 4px;
  font-size: 20px;
  font-weight: 500;
  color: #feffff;
`;

// .profile-card .text-gray-400
export const Subtitle = styled.span`
  font-size: 14px;
  color: antiquewhite;
  text-align: center;
  color: oklch(0.707 0.022 261.325)
;
`;

// .profile-card .store-buttons
export const StoreButtons = styled.div`
  margin-top: 20%;
  width: 50%;
  display: flex;
  flex-direction: column;
  flex-basis: auto;
  gap: 16px;
  justify-content: center;
  align-items: center;

  @media (min-width: 640px) {
    flex-direction: row;
    gap: 16px;
  }
`;

// .profile-card .store-buttons a
export const StoreButtonBase = styled.a`
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 16px;
  border-radius: 0.5rem;
  text-decoration: none;
  cursor: pointer;
  color: #feffff;
  background-color: rgb(228 109 214 / 54%);

  @media (min-width: 640px) {
    flex-direction: row;
  }
`;

// .profile-card .store-buttons a.disabled
export const StoreButtonDisabled = styled(StoreButtonBase)`
  background-color: inherit;
  border: 1px rgba(254, 255, 255, 0.2) solid;
  cursor: default;
`;

// активная кнопка (как обычный <a> без .disabled)
export const StoreButton = styled(StoreButtonBase)`
  border: none;
    background: rgba(255, 255, 255, 0.1); /* Полупрозрачный белый фон */
    backdrop-filter: blur(20px); /* Размытие того, что находится позади блока */
    -webkit-backdrop-filter: blur(20px); /* Для поддержки Safari */
    border: 1px solid rgba(255, 255, 255, 0.3); /* Тонкая полупрозрачная рамка */
    border-radius: 20px; /* Скругленные углы, как у Apple */
    //box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37); /* Мягкая тень */

  &:hover {
    filter: brightness(1.05);
  }
`;

export const StoreText = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
`;

export const StoreTextSmall = styled.div`
  font-size: 14px;
  margin-bottom: 2px;
`;

export const StoreTextStrong = styled.div`
  margin-top: -2px;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #feffff;
`;

// h5 и svg в .profile-card были белыми
export const AppleIcon = styled.svg`
  width: 28px;
  height: 28px;
  margin-right: 12px;
  color: #feffff;
`;

export const GoogleIcon = styled.svg`
  width: 28px;
  height: 28px;
  margin-right: 8px;
  color: #feffff;
`;